module.exports = __webpack_public_path__ + "static/media/menu.5b2172e2.svg";